import React, { useEffect, useState } from 'react';

import {
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  Select,
  TextField,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchSubSystems,
  fetchVehicleTypes,
  fetchAccessibilityType,
  fetchFuelType,
  fetchVehicleClassification,
  fetchVehicleCategories,
  fetchVehicleModels,
  fetchVehicleBrands,
} from 'app/store/slices/vehicle';
import { Field } from 'formik';

const VehicleData = props => {
  const { classes, vehicle, canEdit, errors, values } = props;
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const vehicleType = useSelector(state => state.vehicle.vehicleType);
  const vehicleCategories = useSelector(state => state.vehicle.vehicleCategories);
  const vehicleModels = useSelector(state => state.vehicle.vehicleModels);
  const vehicleBrands = useSelector(state => state.vehicle.vehicleBrands);
  const subSystems = useSelector(state => state.vehicle.subSystems);
  const accessibilityType = useSelector(state => state.vehicle.accessibilityType);
  const fuelType = useSelector(state => state.vehicle.fuelType);
  const vehicleClassification = useSelector(state => state.vehicle.vehicleClassification);

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      const promisses = [];
      if (vehicleType.length === 0) promisses.push(dispatch(fetchVehicleTypes()));
      if (vehicleCategories.length === 0) promisses.push(dispatch(fetchVehicleCategories()));
      if (accessibilityType.length === 0) promisses.push(dispatch(fetchAccessibilityType()));
      if (vehicleModels.length === 0) promisses.push(dispatch(fetchVehicleModels()));
      if (vehicleBrands.length === 0) promisses.push(dispatch(fetchVehicleBrands()));
      if (fuelType.length === 0) promisses.push(dispatch(fetchFuelType()));
      if (vehicleClassification.length === 0)
        promisses.push(dispatch(fetchVehicleClassification()));
      if (subSystems.length === 0) promisses.push(dispatch(fetchSubSystems()));
      if (promisses.length > 0) await Promise.all(promisses);
      setLoading(false);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const validateAcessibilidade = value => {
    let error;
    if (vehicle.qtCapacidade >= 22 && vehicle.deUtilizacao === 'Sistema' && value === '') {
      error = 'Campo obrigatório';
    }
    return error;
  };

  if (loading) {
    return (
      <Grid item xs={12} className={classes.centerProgress}>
        <CircularProgress size={20} />
      </Grid>
    );
  }

  return (
    <>
      <Grid item xs={12}>
        <h2 className={classes.title}>Dados do veículo</h2>
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextField
          name="dePlaca"
          label={'Placa*'}
          variant="filled"
          value={vehicle.dePlaca}
          margin="dense"
          disabled={true}
          fullWidth
          inputProps={{
            maxLength: 7,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          name="deRenavam"
          label={'Renavam*'}
          variant="filled"
          margin="dense"
          disabled={true}
          fullWidth
          value={vehicle.deRenavam}
          inputProps={{
            maxLength: 11,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          name="deChassi"
          label={'Nº Chassi*'}
          variant="filled"
          margin="dense"
          disabled={true}
          fullWidth
          value={vehicle.deChassi}
          inputProps={{
            maxLength: 17,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          name="nuAnoFabricacao"
          label={'Ano Fabricação*'}
          variant="filled"
          margin="dense"
          disabled={true}
          fullWidth
          value={vehicle.nuAnoFabricacao}
          inputProps={{
            maxLength: 4,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl variant="filled" margin="dense" disabled={true} fullWidth>
          <InputLabel htmlFor="cdMarca">Marca*</InputLabel>
          <Select name="cdMarca" id="cdMarca" native value={vehicle.modelo?.cdMarca}>
            <option aria-label="None" value="" />
            {vehicleBrands.map((elem, index) => {
              return (
                <option key={`type-${index}`} value={elem.cdMarca}>
                  {elem.deMarca}
                </option>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl variant="filled" margin="dense" disabled={true} fullWidth>
          <InputLabel htmlFor="cdModelo">Modelo*</InputLabel>
          <Select name="cdModeloVeiculo" id="cdModeloVeiculo" native value={vehicle.cdModelo}>
            <option aria-label="None" value="" />
            {vehicleModels.map((elem, index) => {
              return (
                <option key={`type-${index}`} value={elem.cdModeloVeiculo}>
                  {elem.deModelo}
                </option>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          name="nuAnoModelo"
          label={'Ano Modelo*'}
          variant="filled"
          margin="dense"
          disabled={true}
          fullWidth
          value={vehicle.nuAnoModelo}
          inputProps={{
            maxLength: 4,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl variant="filled" margin="dense" disabled={true} fullWidth>
          <InputLabel htmlFor="cdCategoriaVeiculo">Categoria*</InputLabel>
          <Select
            name="cdCategoriaVeiculo"
            id="cdCategoriaVeiculo"
            native
            value={vehicle.cdCategoriaVeiculo}
          >
            <option aria-label="None" value="" />
            {vehicleCategories.map((elem, index) => {
              return (
                <option key={`type-${index}`} value={elem.cdCategoriaVeiculo}>
                  {elem.deCategoriaVeiculo}
                </option>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl variant="filled" margin="dense" disabled={true} fullWidth>
          <InputLabel htmlFor="cdTipoCombustivel">Combustível*</InputLabel>
          <Select
            name="cdTipoCombustivel"
            id="cdTipoCombustivel"
            native
            value={vehicle.cdTipoCombustivel}
          >
            <option aria-label="None" value="" />
            {fuelType.map((elem, index) => {
              return (
                <option key={`comb-${index}`} value={elem.cdTipoCombustivel}>
                  {elem.deTipoCombustivel}
                </option>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          name="qtCapacidade"
          label="Capacidade*"
          variant="filled"
          margin="dense"
          disabled={true}
          fullWidth
          value={vehicle.qtCapacidade}
          inputProps={{
            maxLength: 3,
          }}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextField
          name="deUtilizacao"
          label="Utilização*"
          variant="filled"
          margin="dense"
          disabled={true}
          fullWidth
          value={vehicle.deUtilizacao}
          inputProps={{
            maxLength: 3,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl variant="filled" margin="dense" disabled={true} fullWidth>
          <InputLabel htmlFor="cdSubSistema">Subsistema*</InputLabel>
          <Select name="cdSubSistema" id="cdSubSistema" native value={vehicle.cdSubSistema}>
            <option aria-label="None" value="" />
            {subSystems.map((elem, index) => {
              return (
                <option key={`sub-${index}`} value={elem.cdSubSistema}>
                  {elem.deSubSistema}
                </option>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl
          variant="filled"
          margin="dense"
          disabled={!canEdit}
          fullWidth
          error={!!errors.cdTipoVeiculo}
        >
          <InputLabel htmlFor="cdTipoVeiculo">Tipo de veículo*</InputLabel>
          <Field
            name="veiculo.cdTipoVeiculo"
            id="cdTipoVeiculo"
            native
            as={Select}
            value={values.veiculo?.cdTipoVeiculo}
          >
            <option aria-label="None" value="" />
            {vehicleType.map((elem, index) => {
              return (
                <option key={`type-${index}`} value={elem.cdTipoVeiculo}>
                  {elem.deTipoVeiculo}
                </option>
              );
            })}
          </Field>
          {errors.cdTipoVeiculo ? <FormHelperText>{errors.cdTipoVeiculo}</FormHelperText> : null}
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl
          variant="filled"
          margin="dense"
          disabled={!canEdit}
          fullWidth
          error={!!errors.cdTipoAcessibilidade}
        >
          <InputLabel htmlFor="cdTipoAcessibilidade">Tipo de Acessibilidade</InputLabel>
          <Field
            name="veiculo.cdTipoAcessibilidade"
            id="cdTipoAcessibilidade"
            native
            as={Select}
            value={values.veiculo?.cdTipoAcessibilidade}
            validate={validateAcessibilidade}
          >
            <option aria-label="None" value="" />
            {accessibilityType.map((elem, index) => {
              return (
                <option key={`access-${index}`} value={elem.cdTipoAcessibilidade}>
                  Letra {elem.sgTipoAcessibilidade}
                </option>
              );
            })}
          </Field>
          {errors.cdTipoAcessibilidade ? (
            <FormHelperText>{errors.cdTipoAcessibilidade}</FormHelperText>
          ) : null}
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl
          variant="filled"
          margin="dense"
          disabled={!canEdit}
          fullWidth
          error={!!errors.cdClassificacaoVeiculo}
        >
          <InputLabel htmlFor="cdClassificacaoVeiculo">Classificação*</InputLabel>
          <Field
            name="veiculo.cdClassificacaoVeiculo"
            id="cdClassificacaoVeiculo"
            native
            as={Select}
            value={values.veiculo?.cdClassificacaoVeiculo}
          >
            <option aria-label="None" value="" />
            {vehicleClassification.map((elem, index) => {
              return (
                <option key={`class-${index}`} value={elem.cdClassificacaoVeiculo}>
                  {elem.deClassificacaoVeiculo}
                </option>
              );
            })}
          </Field>
          {errors.cdClassificacaoVeiculo ? (
            <FormHelperText>{errors.cdClassificacaoVeiculo}</FormHelperText>
          ) : null}
        </FormControl>
      </Grid>
    </>
  );
};

export default VehicleData;
